import React, {useState} from 'react'
import {Footer} from "../footer";

export const BusinessDetails = (props) => {
  const [data, setData] = useState(props.data || {})

  const onChange = (fieldName) => {
    return (e) => {
      e.preventDefault()
      setData({...data, [fieldName]: e.target.value})
    }
  }

  const onSubmit = (e) => {
    e.preventDefault()
    props.onNext(data)
  }

  const fields = [
    {
      field: 'brokerageCurrent',
      label: 'What brokerage are you currently with?',
      required: true
    },
    {
      field: 'listingsPerMonth',
      label: 'How many listings do you handle per month?',
      required: true
    },
    {
      field: 'primaryLocation',
      label: 'What town/county are most of your listings located?',
      required: true
    }
  ]

  return <form onSubmit={onSubmit}>
    <div className="schedule-demo-title">
      Let's hear about your business.
    </div>

    <div className="schedule-demo-form-fields schedule-demo-business-details-form-fields">
      {fields.map(field => (
        <div className="schedule-demo-form-field" key={field.field}>
          <label className={`schedule-demo-business-info-form-field-label formLabel ${field.required ? 'required' : ''}`}>
            {field.label}
          </label>

          <input value={data[field.field]} onChange={onChange(field.field)}
                 className="formInput" placeholder="Content" required={field.required}/>
        </div>
      ))}
    </div>

    <Footer onBack={props.onBack}/>
  </form>
}